import React from "react";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import Section from "./Section";

const terms = [
  "Mobile app builds",
  "Backend systems and APIs",
  "Payments and subscriptions",
  "Launch support",
];

export default function Pricing() {
  return (
    <Section id="pricing" subtitle="Rates" title="Clear starting point">
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-7 border-2 border-black dark:border-white bg-black text-white dark:bg-white dark:text-black p-7 sm:p-10">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-white/60 dark:text-black/60">
            Project builds
          </p>
          <div className="mt-8 flex items-end gap-4">
            <span className="font-display text-6xl sm:text-7xl leading-none">$3,500</span>
            <span className="pb-2 font-mono text-xs uppercase tracking-[0.2em] text-white/60 dark:text-black/60">
              starting from
            </span>
          </div>
          <p className="mt-7 max-w-xl text-base sm:text-lg leading-relaxed text-white/75 dark:text-black/70">
            A serious starting point for scoped apps, MVPs, backend builds, and launch-ready product work.
            Larger full-stack, fintech, marketplace, or payment systems are quoted after requirements are clear.
          </p>
          <a
            href="#contact"
            className="mt-8 inline-flex items-center gap-2 border-2 border-white dark:border-black px-5 py-3 font-mono text-xs font-bold uppercase tracking-[0.18em] hover:bg-white hover:text-black dark:hover:bg-black dark:hover:text-white transition-colors"
          >
            Send a brief <FiArrowRight className="shrink-0" aria-hidden />
          </a>
        </div>

        <div className="lg:col-span-5 grid gap-6">
          <div className="border-2 border-black/15 dark:border-white/20 bg-white/85 dark:bg-black/60 p-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-stone-500 dark:text-stone-500">
              Hourly work
            </p>
            <p className="mt-5 font-display text-5xl leading-none text-black dark:text-white">$35/hr</p>
            <p className="mt-5 text-sm leading-relaxed text-stone-600 dark:text-stone-400">
              Best for audits, fixes, feature work, refactors, integrations, and ongoing product support.
            </p>
          </div>

          <div className="border-2 border-black/15 dark:border-white/20 bg-white/85 dark:bg-black/60 p-7">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-stone-500 dark:text-stone-500">
              Typical scope
            </p>
            <div className="mt-5 grid gap-3">
              {terms.map((term) => (
                <div key={term} className="flex items-center gap-3 text-sm font-medium text-stone-800 dark:text-stone-200">
                  <FiCheck className="shrink-0 text-black dark:text-white" aria-hidden />
                  <span>{term}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
